import styled from "styled-components";
import { BackGroundImage } from "../../../../../public/assets";

export const CompleteAccountContainer = styled.div`
  /* width: 100%; */
  height: 138px;
  background-color: #def2de;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  align-items: center;
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 5px;
    /* border-radius: 0.625rem; */
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const CompleteAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const CompleteAccountContent = styled.div``;
export const CompleteSetUp = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;
export const CompleteH1 = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 26px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.5px;
  color: #09005b;
  margin-bottom: 0px;
  @media only screen and (max-width: 767px) {
    font-size: 1.125rem;
    font-weight: 700;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;
export const CompleteP1 = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  margin-bottom: 0px;
  @media only screen and (max-width: 767px) {
    font-size: 0.875rem;
    width: 80%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;

export const CompleteP2 = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  margin-right: 5px;
  @media only screen and (max-width: 767px) {
    font-size: 0.875rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;
export const HorizontalLine = styled.div`
  width: 31px;
  height: 0px;
  border: 1px solid #5e5e5e;
  margin-right: 5px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const Round = styled.div`
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: GT Walsheim Pro;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  margin-right: 5px;
`;
export const CompleteButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const NumberWrapper = styled.div`
  display: flex;
  align-items: center;
`;
